import { createClient } from "../http-client";
import { AxiosInstance, AxiosResponse } from 'axios';
import {getBaseUrlOneApi, prefixBaseUrlOneApi} from "@/helper";



export class ChangeMotivationService {

    constructor(private client : AxiosInstance) {
        this.client = client;
    }

    async getByBrandId(brandId: number): Promise<AxiosResponse> {
        return await this.client.get(prefixBaseUrlOneApi + "/changeMotivation/brandId/" + brandId, { baseURL: getBaseUrlOneApi() });
    }
}

export async function createChangeMotivationService(app) : Promise<ChangeMotivationService> {
    const client = await createClient(app);
    return new ChangeMotivationService(client);
}
